
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      menuItems: null,
      selectedPage: null,
    };
  },
  computed: {
    siteSubmenus () {
      return this.siteSettings.submenus;
    },
    submenu () {
      if (this.siteSubmenus.length) {
        for (const menu of [...this.siteSubmenus]) {
          // If page exists in a sibling menu, return the menu
          if (
            [...menu.menu_items].find(
              item => item.menu_page.ID === this.post.id,
            )
          ) {
            return menu;
          }
        }
      }
      return false;
    },
  },
  watch: {
    selectedPage () {
      this.$router.push(this.selectedPage);
    },
  },
  mounted () {
    if (this.submenu) {
      this.getPages(); // ACF doesn't give us the full slug in the menu item, so we need to get it
    }
  },
  methods: {
    async getPages () {
      const pageIds = [...this.submenu.menu_items].map(
        item => item.menu_page.ID,
      );
      const params = {
        fields: `id,slug`,
        posts: {
          posts_per_page: this.submenu.menu_items.length,
          post_type: `page`,
          post__in: pageIds,
          orderby: `post__in`,
          post_status: `publish`,
        },
      };

      const request = await this.$getPosts(`/posts`, params);
      if (request !== null) {
        this.menuItems = request;
        this.selectedPage = this.getPageSlug(this.post.id);
      }
    },
    getPageSlug (itemId) {
      const page = [...this.menuItems].find(item => item.id === itemId);
      return page ? page.slug : false;
    },
    isActive (currentItem) {
      return this.post.id === currentItem.menu_page.ID;
    },
  },
};
